function redirectAppStoreIfMobile(path) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return ({ path });
  }
  if (/android/i.test(userAgent)) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.acvauctions.acvauctions';
    return '/redirected';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href = 'itms://apps.apple.com/us/app/acv-auctions/id969808943';
    return '/redirected';
  }
  return ({ path });
}

export default redirectAppStoreIfMobile;
